import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { CheckoutReview } from "@components/organisms";
import { statuses as dummyStatuses } from "@components/organisms/DummyPaymentGateway";
import { useCheckout } from "@saleor/sdk";

var CheckoutReviewSubpageWithRef = function CheckoutReviewSubpageWithRef(_ref, ref) {
  var _checkout$shippingAdd, _checkout$billingAddr, _checkout$shippingMet;

  var selectedPaymentGatewayToken = _ref.selectedPaymentGatewayToken,
      paymentGatewayFormRef = _ref.paymentGatewayFormRef,
      changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      props = _objectWithoutProperties(_ref, ["selectedPaymentGatewayToken", "paymentGatewayFormRef", "changeSubmitProgress", "onSubmitSuccess"]);

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      payment = _useCheckout.payment,
      completeCheckout = _useCheckout.completeCheckout;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var checkoutShippingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress) ? _objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress, {
    phone: (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingAdd = checkout.shippingAddress) === null || _checkout$shippingAdd === void 0 ? void 0 : _checkout$shippingAdd.phone) || undefined
  }) : undefined;
  var checkoutBillingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress) ? _objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress, {
    phone: (checkout === null || checkout === void 0 ? void 0 : (_checkout$billingAddr = checkout.billingAddress) === null || _checkout$billingAddr === void 0 ? void 0 : _checkout$billingAddr.phone) || undefined
  }) : undefined;

  var getPaymentMethodDescription = function getPaymentMethodDescription() {
    if ((payment === null || payment === void 0 ? void 0 : payment.gateway) === "mirumee.payments.dummy") {
      var _dummyStatuses$find;

      return "Rechnung: ".concat((_dummyStatuses$find = dummyStatuses.find(function (status) {
        return status.token === selectedPaymentGatewayToken;
      })) === null || _dummyStatuses$find === void 0 ? void 0 : _dummyStatuses$find.label);
    }

    if ((payment === null || payment === void 0 ? void 0 : payment.gateway) === "mirumee.payments.adyen") {
      return "Adyen payments";
    }

    if (payment === null || payment === void 0 ? void 0 : payment.creditCard) {
      return "Ending in ".concat(payment === null || payment === void 0 ? void 0 : payment.creditCard.lastDigits);
    }

    return "";
  };

  useImperativeHandle(ref, function () {
    return {
      complete: function () {
        var _complete = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var data, dataError, _paymentGatewayFormRe, _dataError, response, _errors, _data, _data$order, _data2, _data2$order, _data3, _data3$order;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  changeSubmitProgress(true);

                  if (!((payment === null || payment === void 0 ? void 0 : payment.gateway) === "mirumee.payments.adyen")) {
                    _context.next = 5;
                    break;
                  }

                  (_paymentGatewayFormRe = paymentGatewayFormRef.current) === null || _paymentGatewayFormRe === void 0 ? void 0 : _paymentGatewayFormRe.dispatchEvent(new Event("submitComplete", {
                    cancelable: true
                  }));
                  _context.next = 13;
                  break;

                case 5:
                  _context.next = 7;
                  return completeCheckout();

                case 7:
                  response = _context.sent;
                  data = response.data;
                  dataError = response.dataError;
                  changeSubmitProgress(false);
                  _errors = (_dataError = dataError) === null || _dataError === void 0 ? void 0 : _dataError.error;

                  if (_errors) {
                    setErrors(_errors);
                  } else {
                    setErrors([]);
                    onSubmitSuccess({
                      id: (_data = data) === null || _data === void 0 ? void 0 : (_data$order = _data.order) === null || _data$order === void 0 ? void 0 : _data$order.id,
                      orderNumber: (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$order = _data2.order) === null || _data2$order === void 0 ? void 0 : _data2$order.number,
                      token: (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$order = _data3.order) === null || _data3$order === void 0 ? void 0 : _data3$order.token
                    });
                  }

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function complete() {
          return _complete.apply(this, arguments);
        }

        return complete;
      }()
    };
  });
  return React.createElement(CheckoutReview, _extends({}, props, {
    shippingAddress: checkoutShippingAddress,
    billingAddress: checkoutBillingAddress,
    shippingMethodName: checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingMet = checkout.shippingMethod) === null || _checkout$shippingMet === void 0 ? void 0 : _checkout$shippingMet.name,
    paymentMethodName: getPaymentMethodDescription(),
    email: checkout === null || checkout === void 0 ? void 0 : checkout.email,
    errors: errors
  }));
};

var CheckoutReviewSubpage = forwardRef(CheckoutReviewSubpageWithRef);
export { CheckoutReviewSubpage };